import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { gbp } from "@/lib/api";

export const PlanCard = ({ plan, i, onSubscribe, onQuote }) => {
  const dark = !!plan.featured;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8 }}
      className={`relative flex flex-col rounded-[28px] p-8 sm:p-10 ${dark ? "bg-[#141412] text-[#FAF8F5] shadow-2xl" : "border border-stone-300 bg-white"}`}
      data-testid={`plan-card-${plan.lookup_key}`}
    >
      {dark && <span className="absolute -top-3 left-8 rounded-full bg-[#C59B27] px-4 py-1 text-xs font-bold text-[#141412]">Most chosen</span>}
      <p className={`eyebrow ${dark ? "text-[#C59B27]" : "text-[#9a7614]"}`}>0{i + 1}</p>
      <h3 className="mt-3 font-display text-4xl font-semibold">{plan.name}</h3>
      <p className="mt-6 flex items-baseline gap-2">
        <span className="font-display text-5xl font-bold" data-testid={`plan-price-${plan.lookup_key}`}>{gbp(plan.amount)}</span>
        <span className={dark ? "text-stone-300" : "text-stone-600"}>/ month</span>
      </p>
      <p className={`mt-1 text-xs ${dark ? "text-stone-400" : "text-stone-600"}`}>Per site, starting price. Excl. VAT.</p>
      <ul className="mt-8 flex-1 space-y-3">
        {(plan.features ?? []).map((f) => (
          <li key={f} className="flex gap-3 text-sm">
            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-[#C59B27]" : "text-[#3E4A3D]"}`} />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <div className="mt-10 grid gap-3">
        <button onClick={() => onSubscribe(plan)} className={dark ? "btn-gold justify-center" : "btn-ink justify-center"} data-testid={`plan-subscribe-${plan.lookup_key}`}>
          Subscribe now
        </button>
        <button onClick={() => onQuote(plan)} className={`btn-ghost justify-center ${dark ? "text-[#FAF8F5] hover:bg-white/10" : "hover:bg-stone-100"}`} data-testid={`plan-quote-${plan.lookup_key}`}>
          Request a quote
        </button>
      </div>
    </motion.div>
  );
};
